export default __webpack_public_path__ + "static/media/background.109e3b7f.png";